export default __webpack_public_path__ + "static/media/vantaggio.6aa1a343.jpg";